// Third-party
import React from 'react';

// Components
import Tooltip from './Tooltip';

type Props = {
  message: string;
  title?: string;
  list?: Array<any>;
  place?: 'bottom' | 'top' | 'left' | 'right';
};

const ErrorTooltip = (props: Props) => (
  <Tooltip className="error-tooltip tooltip-icon" icon="icon-error" {...props}>
    <i className="icon-error displayed-icon" tabIndex={0} />
  </Tooltip>
);

export default ErrorTooltip;
